import Handler from '@/core/domain/usecase/handler';

const createEquipmentRepository = (axios) => async (data) => {
  try {
    const response = await axios.post(`/equipment`,
      data
    )
    return response.data
  } catch (err) {
    if (err.isAxiosError) {
      throw new Handler().trataErro(err)
    } else {
      throw err
    }
  }
}

export default createEquipmentRepository
